const backendMessageKeyMap = {
  'cannot filter on date before 7 days ago': 'errors.cannotFilterBefore7DaysAgo',
  // Someone else deleted the record while this screen was open: the thing being saved is no longer
  // there, and the answer is to reload rather than to correct anything on the form. The first two
  // are what an API older than the rewording still sends.
  'sale order does not exists': 'errors.orderNoLongerExists',
  'sale does not exists': 'errors.orderNoLongerExists',
  'this order no longer exists. it may have been deleted while this page was open.':
    'errors.orderNoLongerExists',
  // A product on the order was removed from inventory between opening the order and saving it.
  'product not found in inventory': 'errors.orderProductGone',
  'a product on this order is no longer in the inventory.': 'errors.orderProductGone',
  'this club has no default currency set, so a membership cannot be priced. set one in system settings, then try again.': 'errors.noDefaultCurrency',
  // Kept for backends predating the account-lockout wait being reported.
  'too many failed attempts. please try again later.': 'errors.tooManyAttempts',
  'too many requests. please try again later.': 'errors.tooManyRequests',
  // The nightly gate access-control sweep needs an hour and a timezone it can resolve; enabling it
  // without either is refused rather than saved into a schedule that never runs.
  'an update time is required to enable automatic gate access control':
    'errors.autoGateAccessControlNeedsTime',
  'a recognised timezone is required to enable automatic gate access control':
    'errors.autoGateAccessControlNeedsTimezone',
  'automatic gate access control update time must be a time of day, such as 02:00':
    'errors.autoGateAccessControlBadTime',
};

// The account-lockout message carries the remaining wait, so it can't be matched by exact text.
const lockoutRetryInPattern = /^too many failed attempts\. please try again in (\d+) minutes?\.$/;

function getBackendMessage(data) {
  if (!data) {
    return '';
  }

  if (typeof data === 'string') {
    return data;
  }

  return data.en
    || data.Title || data.title
    || data.Message || data.message
    || data.Detail || data.detail
    || data.TitleEn || data.titleEn
    || data.MessageEn || data.messageEn
    || data.DetailEn || data.detailEn
    || data.ar
    || data.TitleAr || data.titleAr
    || data.MessageAr || data.messageAr
    || data.DetailAr || data.detailAr
    || '';
}

function getMappedMessage(message, locale, t) {
  if (!message || !t) {
    return '';
  }

  const normalized = String(message).trim().toLowerCase();

  const lockoutRetryIn = normalized.match(lockoutRetryInPattern);
  if (lockoutRetryIn) {
    return locale === 'ar'
      ? t('errors.tooManyAttemptsRetryIn', { minutes: Number(lockoutRetryIn[1]) })
      : message;
  }

  const messageKey = backendMessageKeyMap[normalized];
  if (!messageKey) {
    return '';
  }

  if (locale === 'ar') {
    return t(messageKey);
  }

  return message;
}

export function getLocalizedBackendMessage(data, locale, t) {
  if (!data) {
    return '';
  }

  const backendMessage = getBackendMessage(data);
  const mappedMessage = getMappedMessage(backendMessage, locale, t);
  if (mappedMessage) {
    return mappedMessage;
  }

  if (locale === 'ar') {
    return data.ar
      || data.TitleAr || data.titleAr
      || data.MessageAr || data.messageAr
      || data.DetailAr || data.detailAr
      || backendMessage
      || '';
  }

  return backendMessage;
}
